import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useReactRouter from "use-react-router";
import {
  MdDelete,
  MdOutlineArrowBackIosNew,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";
import { BsPlusLg } from "react-icons/bs";
import React from "react";
import { Button, Form, FormControl, InputGroup, Table } from "react-bootstrap";
import { Switch } from "@material-ui/core";

function OrderlistEdit() {
  const { history } = useReactRouter();
  const _gotoOrderList = () => {
    history.push(`/orderlist`);
  };
  return (
    <div>
      <div
        style={{
          borderBottom: "1px solid #B8B3B3",
          padding: 10,
        }}
        onClick={() => _gotoOrderList()}
      >
        <MdOutlineArrowBackIosNew style={{ fontSize: 14, marginRight: 30 }} />
        <span style={{ fontSize: 18, fontWeight: "bold" }}> ແກ້ໄຂອໍເດີ້</span>
      </div>
      <div style={{ marginTop: 34 }}>
        <Form.Group className="mb-3">
          <Form.Label>
            <span style={{ color: "#5C5C5C" }}> ເລກທີ່ໃບສັ່ງຊື້</span>
            <span style={{ color: "red" }}>*</span>
          </Form.Label>
          <Form.Control placeholder="002" disabled />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            <span style={{ color: "#5C5C5C" }}> ວັນທີ່ສັ່ງຊື້</span>
            <span style={{ color: "red" }}>*</span>
          </Form.Label>
          <div
            style={{
              border: "1px solid #B8B3B3",
              display: "flex",
              justifyContent: "space-between",
              height: 40,
              padding: 9,
            }}
          >
            <div> 15/03/2022</div>
            <div style={{ marginRight: 12 }}>
              <FontAwesomeIcon icon={faCalendarAlt} />
            </div>
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            <span style={{ color: "#5C5C5C" }}> ສະຖານະອໍເດີ້</span>
            <span style={{ color: "red" }}>*</span>
          </Form.Label>
          <div
            style={{
              border: "1px solid #B8B3B3",
              display: "flex",
              justifyContent: "space-between",
              height: 40,
              padding: 9,
            }}
          >
            <div>ອໍເດີ້ເຂັົ້າ</div>
            <div style={{ marginRight: 12, fontSize: 18 }}>
              <MdOutlineKeyboardArrowDown />
            </div>
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            <span style={{ color: "#5C5C5C" }}> ຊື່ລູກຄ້າ</span>
            <span style={{ color: "red" }}>*</span>
          </Form.Label>
          <div
            style={{
              border: "1px solid #B8B3B3",
              display: "flex",
              justifyContent: "space-between",
              height: 40,
              padding: 9,
            }}
          >
            <div> ສຸກສະຫວັນ</div>
          </div>
        </Form.Group>
        <div>
          ລູກຄ້າມີບັນຊີFacebook
          <label>
            <Switch />
          </label>
        </div>

        <Form.Group className="mb-3">
          <Form.Label>
            ຊື່Facebook ລູກຄ້າ<span style={{ color: "red" }}>*</span>
          </Form.Label>
          <InputGroup className="mb-3">
            <FormControl placeholder="ກະລຸນາປ້ອນ" />
          </InputGroup>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>
            <span style={{ color: "#5C5C5C" }}> ເບີໂທ</span>
            <span style={{ color: "red" }}>*</span>
          </Form.Label>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: 40,
              padding: 9,
              border: "1px solid #B8B3B3",
            }}
          >
            0299999999
          </div>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>ທີ່ຢູ່ປາຍທາງ</Form.Label>
          <Form.Control
            as="textarea"
            placeholder="ຕົວຢ່າງ:ຊື່ຂົນສົ່ງ,ບ້ານ,ເມືອງ,ແຂວງ"
            style={{ height: "100px" }}
          />
        </Form.Group>

        <Table style={{display:"flex"}}>
          <thead>
            <tr>
              <th style={{borderTop:"none",borderBottom:"none"}}>#</th>
              <th style={{borderTop:"none",borderBottom:"none"}}>ລະຫັດCF </th>
              <th style={{borderTop:"none",borderBottom:"none"}}>ຈຳນວນ</th>
              <th style={{borderTop:"none",borderBottom:"none"}}>ລາຄາ</th>
              <th style={{borderTop:"none",borderBottom:"none"}}> ທັງໝົດ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>001</td>
              <td>
                <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  T22
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  9
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 54,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 74,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  10,500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 30,
                    height:30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:"#D21C1C",
                    borderRadius:3
                  }}
                >
                <MdDelete style={{ color: "#FFFF" }} />
                </div>
              </td>
            </tr>
            <tr>
              <td>001</td>
              <td>
                <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  T22
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  9
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 54,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 74,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  10,500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 30,
                    height:30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:"#D21C1C",
                    borderRadius:3
                  }}
                >
                <MdDelete style={{ color: "#FFFF" }} />
                </div>
              </td>
            </tr>
            <tr>
              <td>001</td>
              <td>
                <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  T22
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  9
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 54,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 74,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  10,500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 30,
                    height:30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:"#D21C1C",
                    borderRadius:3
                  }}
                >
                <MdDelete style={{ color: "#FFFF" }} />
                </div>
              </td>
            </tr>
            <tr>
              <td>001</td>
              <td>
                <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  T22
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  9
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 54,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 74,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  10,500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 30,
                    height:30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:"#D21C1C",
                    borderRadius:3
                  }}
                >
                <MdDelete style={{ color: "#FFFF" }} />
                </div>
              </td>
            </tr>
            <tr>
              <td>001</td>
              <td>
                <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  T22
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  9
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 54,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 74,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  10,500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 30,
                    height:30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:"#D21C1C",
                    borderRadius:3
                  }}
                >
                <MdDelete style={{ color: "#FFFF" }} />
                </div>
              </td>
            </tr>
            <tr>
              <td>001</td>
              <td>
                <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  T22
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 44,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  9
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 54,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 74,
                    height:38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:3
                  }}
                >
                  10,500,000
                </div>
              </td>
              <td>
              <div
                  style={{
                    border: "1px solid #D1D5DB",
                    width: 30,
                    height:30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:"#D21C1C",
                    borderRadius:3
                  }}
                >
                <MdDelete style={{ color: "#FFFF" }} />
                </div>
              </td>
            </tr>
          </tbody>
        </Table>

        <div style={{ marginTop: 24, marginLeft: 18 }}>
          <Button style={{ background: "#E8EDF1", border: "none" }}>
            <BsPlusLg style={{ color: "#252A31" }} />
            <span
              style={{ color: "#252A31", fontSize: 12, fontWeight: "bold" }}
            >
              ເພີ່ມລາຍການ
            </span>
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 45,
          }}
        >
          <div style={{ marginLeft: 18, fontSize: 14 }}>ເກັບເງີນຕົ້ນທາງ</div>

          <label style={{ width: 36, height: 22 }}>
            <Switch />
          </label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 26,
          }}
        >
          <div style={{ marginLeft: 18, fontSize: 14 }}>ເກັບເງີນຕົ້ນທາງ</div>

          <label style={{ width: 36, height: 22 }}>
            <Switch />
          </label>
        </div>
        <div>
          <Form.Group className="mb-3">
            <Form.Label>ລວມທັງໝົດ</Form.Label>
            <div
              style={{
                border: "1px solid grey",
                background: "#F5F5F5",
                height: 40,
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <div style={{ fontWeight: "bold", color: "black" }}>₭ 246 000</div>
            </div>
          </Form.Group>
          <div
            style={{
              marginTop: 70,
              border: "1px solid grey",
              background: "  #422F90",
              height: 40,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ color: "#FFFFFF" }}>Save</div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 24,
              color: "#D21C1C",
            }}
          >
            Cancle
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderlistEdit;
